import type { ReactNode } from 'react'
import { cx } from './cx'
import { Eyebrow } from './Eyebrow'
import { Icon, type IconName } from './Icon'
import styles from './StatTile.module.css'

interface StatTileProps {
  icon: IconName
  label: string
  value: ReactNode
  meta?: ReactNode
  onClick?: () => void
  active?: boolean
}

export function StatTile({ icon, label, value, meta, onClick, active }: StatTileProps) {
  return (
    <button
      type="button"
      className={cx(styles.tile, active && styles.active, onClick && styles.clickable)}
      onClick={onClick}
      disabled={!onClick}
    >
      <div className={styles.top}>
        <div className={styles.badge}>
          <Icon name={icon} size={20} />
        </div>
        {onClick && <Icon name="chevron_right" size={18} color="var(--color-text-tertiary)" />}
      </div>
      <div>
        <Eyebrow>{label}</Eyebrow>
        <div className={cx(styles.value, 'tabular-nums')}>{value}</div>
        {meta && <div className={styles.meta}>{meta}</div>}
      </div>
    </button>
  )
}
